import { FC } from 'react';

import {
  Box,
  H4,
  HStack,
  NewButton,
  P,
  VStack,
  legacyTextStyles,
} from '@eluve/components';

import { useAppointmentParams } from '../useAppointmentParams';

import { GoldenSummaryFactForm } from './GoldenSummaryFactForm';
import { useGoldenSummaryFacts } from './useSummaryFacts';

export const GoldenSummaryFactsList: FC = () => {
  const { tenantId, appointmentId } = useAppointmentParams();
  const {
    facts,
    loading,
    isCreating,
    isUpdating,
    isDeleting,
    handleAddNewFact,
    handleFactUpdate,
    handleFactDelete,
  } = useGoldenSummaryFacts(tenantId, appointmentId);

  return (
    <VStack gap={4} className="mt-4">
      <HStack justify="between" align="center" className="w-full">
        <H4>Golden Note & Facts</H4>
        <NewButton
          text="Add New Fact"
          type="primary"
          icon={{ name: 'PlusCircle' }}
          onClick={handleAddNewFact}
          disabled={isCreating}
        />
      </HStack>

      {loading ? (
        <P>Loading facts...</P>
      ) : facts.length === 0 ? (
        <Box className="w-full rounded-md border p-4 text-center">
          <P className={legacyTextStyles.body({ color: 'secondary' })}>
            No facts have been added yet. Use the "Add New Fact" button to
            create facts about this appointment.
          </P>
        </Box>
      ) : (
        <Box className="grid w-full grid-cols-[6fr_4fr_2fr_100px] justify-center gap-6">
          {facts.map((fact) => (
            <GoldenSummaryFactForm
              key={fact.id + fact.updatedAt}
              data={fact}
              onSaveRequested={handleFactUpdate}
              onDeleteRequested={handleFactDelete}
              isSubmitting={isUpdating || isDeleting}
            />
          ))}
        </Box>
      )}
    </VStack>
  );
};

export default GoldenSummaryFactsList;
